import { csx, style } from '@vtex/admin-ui'

import { buildProductImageContainerVariants } from './product-image.styles'

export const table = style({
  width: '100%',
  'td[role=columnheader]:nth-child(2)': {
    paddingLeft: '$space-20',
  },
})

export const lastUpdatedHeader = style({
  display: 'inline-flex',
  width: '100%',
  justifyContent: 'flex-end',
  whiteSpace: 'nowrap',
})

export const pagination = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '$space-3',
  span: {
    width: 'auto !important',
    paddingLeft: '$space-3',
  },
  'span[data-variant=detail]': {
    display: 'none',
  },
})

export const cellContainer = style({
  height: '2.75rem',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  justifyContent: 'end',
})

export const actionsMenu = style({
  zIndex: '$z-9',
  a: {
    textDecoration: 'none',
  },
})

export const betaAlert = style({
  display: 'grid',
  gridTemplateColumns: '1fr 73px',
  gap: '$space-2',
  p: {
    maxWidth: 'unset !important',
  },
})

export const productImageContainer = buildProductImageContainerVariants()

export const productNameEllipsis = style({
  display: 'inline-block',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const hovercard = csx({
  bg: '$primary',
  zIndex: 9999,
  padding: '$space-4 $space-5',
  width: '20rem',
  boxShadow: '$overlay.center',
  borderRadius: '$base',
  cursor: 'default',
})

export const iconContainer = csx({ maxHeight: '1rem' })

export const hovercardHeader = csx({
  text: '$action1',
  fg: '$primary',
  fontWeight: 'normal',
})

export const hovercardDescription = style({
  color: '$black',
  text: '$detail',
  '> span': {
    text: '$detail',
    fontVariationSettings: '$display',
  },
})

export const categoryFilterPopover = style({
  width: 'auto',
  minWidth: '16rem',
})

export const categoryFilterList = style({
  padding: '$space-4 $space-5',
  maxHeight: '15rem',
  overflowY: 'scroll',
})

export const categoryFilterHeader = style({
  padding: '$space-4 $space-5 $space-1',
  maxHeight: '15rem',
  overflowY: 'scroll',
})

export const categoryFilterFooter = style({
  borderTop: '$neutral',
  paddingTop: '$space-4',
})

export const productRow = style({
  display: 'contents',
  'td[role=cell]': {
    border: 'unset',
    cursor: 'pointer',
    overflow: 'hidden',
    div: {
      minHeight: 0,
    },
    '> div': {
      paddingY: '$space-2',
      alignItems: 'flex-start',
    },
  },
  'tr > td[role=cell]:nth-child(-n + 2)': {
    paddingX: 'unset',
    paddingLeft: '$space-3',
    '> div': {
      paddingX: 'unset',
    },
  },
  ':hover': {
    'td[role=cell]': {
      bg: '$action.neutral.tertiaryHover',
    },
  },
  'tr[role=row]:hover > td[role=cell]': {
    bg: '$grayTransparent10',
  },
  'tr:last-child > td': {
    borderBottom: '$neutral',
  },
})

export const productColumnsWrapper = style({
  '.product-quick-action': {
    display: 'none',
    '[aria-disabled="true"]': {
      button: {
        cursor: 'not-allowed',
      },
    },
  },
  ':hover': {
    '.product-quick-action': { display: 'revert' },
  },
})

export const alert = style({
  height: 'auto',
  width: '100%',

  p: {
    display: 'flex',
    flexDirection: 'row',
    gap: '$space-2',
  },
})

export const alertIcon = style({
  'div:first-child>svg': {
    display: 'none !important',
  },

  p: {
    margin: '0 !important',
  },
})
